import React from "react";
import "./HeroBanner.css"; // Ajouter un fichier CSS pour styliser

const HeroBanner = () => {
  return (
    <div className="hero-banner">
      <div className="hero-overlay"></div> {/* Overlay sombre */}
      <div className="hero-content">
        <h1 className="hero-title">Fast, Easy, and Reliable Airport Transfers</h1>
        <div className="hero-buttons">
          <a href="#contact" className="btn btn-warning me-3">
            Get in touch
          </a>
          <a href="/rates" className="btn btn-outline-light">
            View more
          </a>
        </div>
      </div>
    </div>
  );
};

export default HeroBanner;
